import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {OK, NO_CONTENT} from 'http-status-codes'
import {make} from 'vuex-pathify'
import _ from 'lodash'

const initialState = {
  results: [],
  builderId: null,
  planNameId: null,
  planNameEnergyPlanId: null,
  autocompleteResults: [],
  fileInUse: false,
  fileName: null
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)

const mutations = make.mutations(state)
mutations.resetResults = (state) => {
  state.results = []
}
mutations.reset = (state) => {
  for (let f in state) {
    Vue.set(state, f, initialState[f])
  }
}
mutations.deleteForm = (state, id) => {
  state.results = _.filter(state.results, (file) => file.id !== id)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchResults({commit, dispatch}, query) {
      const payload = {
        query,
        path: Constants.FOLDERS.ENERGY_PLANS
      }

      const response = await dispatch('files/fetchResults', payload, { root: true })

      if (OK === response.status) {
        commit('results', response.data)
      }

      return response
    },
    async fetchAll({dispatch, state, rootGetters}) {
      const payload = {
        path: Constants.FOLDERS.ENERGY_PLANS
      }
      const response = await dispatch('files/fetchAllByPath', payload, {root: true})

      if (OK === response.status) {
        for (const result of response.data) {
          if (result.hasOwnProperty('uploadedBy')){
            result.uploadedByLabel = rootGetters['users/displayName'](result.uploadedBy)
          }
        }
        state.results = response.data
      }

      return response
    },
    async fetchResultsByEnergyPlanId({commit, dispatch}, fileId) {
      const payload = {
        endpoint: 'files',
        id: fileId
      }
      const response = await dispatch('fetchById', payload, { root: true })
      commit('results', [response.data])
      return response
    },
    async fetchResultsByBuilderId({commit, dispatch}, builderId) {
      let filesResponse = null
      const response = await dispatch('planNames/fetchByBuilderIdWithEnergyPlan', builderId, { root: true })
      if (OK === response.status) {
        const fileIds = _.map(response.data, 'energyPlanId')
        if (fileIds.length > 0) {
          filesResponse = await dispatch('fetchByIds', { ids: fileIds, endpoint: 'files', whichEntity: 'ptracFiles' }, { root: true })
          if (OK === filesResponse.status) {
            // empty responses return an empty object
            if (!Array.isArray(filesResponse.data)) {
              filesResponse.data = []
            }
            commit('results', filesResponse.data)
            return filesResponse
          }
        }
      }
      return response
    },
    async deleteOne({commit, dispatch}, file) {
      const response = await dispatch('files/deleteOne', file, { root: true })
      if (NO_CONTENT === response.status) {
        commit('deleteForm', file.id)
      }
      return response
    }
  }
}
